import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title:
    "Get a drill-down view of the\nnumber of orders in-progress\n across different applications",
  subtitle: "Business Operations Demo",
  text: '<span style="font-weight:bold">OPEX Reduction</span> — giving birds eye view of\n business planning and data driven decision \nmaking.',
  label: { iconPath: "start.png", text: "Reporting - Macro process view " },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_106"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_104"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 2_R1.mp4",
  pageNumber: "ILO_105",
};

export default DATA_BO_DEMO_ILO1;
